export default __webpack_public_path__ + "static/media/Ziggy Stardust & Magic Internet Money.5870b2bd.png";